<template>
  <div class="ict_service-container">

    <div class="ict-container-text">
      <div class="container-text-header">
        <div class="text-header-left">
          <div class="header-left-text1">产品服务</div>
          <div class="header-left-text2">PRODUCT</div>
        </div>
        <div class="text-header-right"></div>
      </div>

      <div class="container-text-first">
        <div class="text-first-box1 box" @click="goToMin_program">
          <div class="first-box1-text1">电商直播小程序</div>
          <div class="first-box1-text2">电商直播小程序深度嵌入公众号，实现粉丝快速变现转化，小程序观看下单，无需下载，流量沉淀无外流。</div>
          <div class="first-box1-img"></div>
          </div>
        <div class="right-box">
          <div class="text-first-box2 box" @click="goToLive">
            <div class="first-box2-text1">电商直播app</div>
            <div class="first-box2-text2">打造企业私域流量，增加品牌与用户链接场景，激活原有沉睡流量，快速成交。</div>
            <div class="first-box2-img"></div>
          </div>
          <div class="text-first-box3 box" @click="goToMin_shopping">
            <div class="first-box2-text1">电商直播微商城</div>
            <div class="first-box2-text2">直播可嵌套多平台商城，营销引流工具打造爆品，提升销量。</div>
            <div class="first-box2-img"></div>
          </div>
        </div>
      </div>
      <div class="container-text-header text-header-s">
        <div class="text-header-left">
          <div class="header-left-text1">成功案例</div>
          <div class="header-left-text2">CASE</div>
        </div>
        <div class="text-header-right"></div>
      </div>
      <div class="animate">
        <img src="../../../../assets/images/组 259.png">
        <img src="../../../../assets/images/组 259.png" class="images-s1">
        <img src="../../../../assets/images/组 259.png" class="images-s2">
        <img src="../../../../assets/images/组 259.png" class="images-s3">
      </div>
    </div>
    <div class="crumbs-nav">
      <svg t="1647833705034" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3680" width="0.2rem" height="0.2rem"><path d="M938.412716 480.847489 556.823881 104.126522c-1.89721-2.258437-6.142907-6.194072-12.037151-10.081613-9.920954-6.544043-21.162995-10.520611-33.496905-10.520611-13.180184 0-24.690332 3.997034-34.357506 10.623965-5.846148 4.010337-9.876951 8.102538-12.157901 11.154038L84.209914 480.894561c-14.700817 14.481829-14.700817 38.014802 0 52.529377 14.585183 14.427594 33.995255 8.343015 50.529837-7.945973l25.607214-25.314549 38.918381-37.700647c-1.359974 1.686409-2.282996 2.963495-2.284019 3.373841L196.981327 847.484797c0 50.006927 40.941458 90.427522 91.442642 90.427522l141.713582 0 10.423397 0L440.560948 927.486876 440.560948 686.440961c0-17.467837 14.411221-31.683607 32.223912-31.683607l77.051887 0c17.814738 0 32.223912 14.21577 32.223912 31.683607L582.060659 927.486876l0 10.425444 10.425444 0 141.713582 0c50.485835 0 91.442642-40.428781 91.442642-90.427522L825.642327 467.251843l62.246693 61.207014c20.142759 13.266142 37.897122 17.434068 50.523697 4.963035C953.114556 518.910387 953.114556 495.361041 938.412716 480.847489z" p-id="3681" fill="#c6c6c6"></path></svg>
      <div class="crumbs-text1" @click="goToHome">首页</div>
      <div class="crumbs-text2">产品服务</div>
      <div class="crumbs-text3">政企数字化</div>
      <img src="../../../../assets/images/路径 93.png" alt="" class="crumbs-img1" @click="goToHome">
      <img src="../../../../assets/images/路径 94.png" alt="" class="crumbs-img2">
      <img src="../../../../assets/images/路径 95.png" alt="" class="crumbs-img3">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/componets/footer/Footer"
export default {
  components: {
    Footer
  },
  methods: {
    goToMin_program() {
      this.$router.push("/products/online/min_program")
    },
    goToLive() {
      this.$router.push("/products/online/live")
    },
    goToMin_shopping() {
      this.$router.push("/products/online/min_shopping")
    },
    goToHome() {
      this.$router.push("/home")
    }
  }
}
</script>

<style lang="less" scoped>
.ict_service-container {
  margin-top: 0.9rem;
  position: relative;
}
//文本内容区域的样式
.ict-container-text {
  width: 12rem;
  text-align: left;
  margin: 0 3.6rem;
  font-size: 0.22rem;
  font-family: Source Han Sans CN;
}
.container-text-header {
  display: flex;
  justify-content:space-between;
  margin-bottom: 0.3rem;
}

.header-left-text1 {
  font-size: 0.38rem;
  font-weight: 500;
  line-height: 0.56rem;
  margin-bottom: 0.1rem;
  color: #333333;
}
.header-left-text2 {
  font-size: 0.28rem;
  font-family: DIN;
  font-weight: normal;
  line-height: 0.38rem;
  color: #747474;
  opacity: 0.5;
}
.text-header-right {
  width: 1.05rem;
  height: 0.2rem;
  margin-top: 0.18rem;
  background-image: url("../../../../assets/images_rectangle/组 155.png");
  background-size: 1.05rem 0.2rem;
}

.box {
  background-color:#F5F6FA ;
  border-top:0.06rem solid #0078FF ;
}
//上部分盒子
.container-text-first {
  width: 12rem;
  height: 7.8rem;
  margin-bottom: 0.3rem;
  display: flex;
  justify-content:space-between;
}
.text-first-box1 {
  width: 5.85rem;
  height: 7.8rem;
  cursor: pointer;
}
.text-first-box2 {
  width: 5.85rem;
  height: 3.75rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
}
.text-first-box3 {
  width: 5.85rem;
  height: 3.75rem;
  cursor: pointer;
}
.first-box1-text1 {
  text-align: center;
  font-size: 0.36rem;
  font-weight: 500;
  line-height: 0.54rem;
  margin-top: 0.6rem;
  margin-bottom: 0.4rem;
  color: #666666;
}
.first-box1-text2 {
  width: 4.9rem;
  height: 4.8rem;
  font-weight: 400;
  line-height: 0.5rem;
  color: #666666;
  border-top: 0.02rem solid #E6E6E6;
  padding-top: 0.4rem;
  box-sizing: border-box;
  margin-left: 0.5rem;
}
.first-box1-img {
   width: 0.47rem;
   height: 0.22rem;
   background-image: url("../../../../assets/images_rectangle/组 156.png");
   background-size: 0.4rem 0.22rem;
   background-repeat: no-repeat;
   margin-left: 4.93rem;
   margin-top: 1.03rem;
}
.first-box2-text1 {
  text-align: center;
  font-size: 0.36rem;
  font-weight: 500;
  line-height: 0.54rem;
  margin-top: 0.3rem;
  margin-bottom: 0.25rem;
  color: #666666;
}
.first-box2-text2 {
  width: 4.9rem;
  height: 2.12rem;
  font-size: 0.22rem;
  font-weight: 400;
  line-height: 0.38rem;
  border-top: 0.02rem solid #E6E6E6;
  margin-left: 0.48rem;
  padding-top: 0.25rem;
  box-sizing: border-box;
  color: #666666;
}
.first-box2-img {
   width: 0.47rem;
   height: 0.22rem;
   background-image: url("../../../../assets/images_rectangle/组 156.png");
   background-size: 0.4rem 0.22rem;
   background-repeat: no-repeat;
   margin-left: 4.91rem;
   margin-top: 0.1rem;
}
.right-box :hover{
  background-color: #0078FF;
  .first-box2-text1 {
    color: #ffffff;
  }
  .first-box2-text2 {
    color: #ffffff;
  }
  .first-box2-img {
    background-image: url("../../../../assets/images_rectangle/组 159.png");
  }
}
.container-text-first :hover {
  background-color: #0078FF;
  .first-box1-text1 {
    color: #ffffff;
  }
  .first-box1-text2 {
    color: #ffffff;
  }
  .first-box1-img {
    background-image: url("../../../../assets/images_rectangle/组 159.png");
  }
}
.text-header-s {
  margin-top: 0.6rem;
}

//底部的图片走马灯效果
.animate {
  width: 12rem;
  overflow: hidden;
  position: relative;
}
.animate img {
  width: 5rem;
  height: 1.68rem;
  animation: move 5s infinite linear;
}
@keyframes move {
  to {
    transform: translate(5rem);
  }
}
.images-s1 {
  position: absolute;
  left: -5rem;

}
.images-s2 {
  position: absolute;
  left: 5rem;

}
.images-s3 {
  position: absolute;
  left: 10rem;

}

//蓝色的面包屑导航
.crumbs-nav {
  width: 6rem;
  height: 0.6rem;
  font-size: 0.16rem;
  position: relative;
  position: absolute;
  top: -1.2rem;
  left: 2.6rem;
}
.crumbs-nav img {
  cursor: pointer;
}
.icon {
  position: absolute;
  top: 0.18rem;
  left: 0.41rem;
  z-index: 99;
}
.crumbs-text1 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 0.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text2 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 1.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text3 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 3.05rem;
  color: #FFFFFF;
  z-index: 99;
}
.crumbs-img1 {
  width: 1.45rem;
  height: 0.6rem;
  position: absolute;
  left: 0;
  z-index: 2;
}
.crumbs-img2 {
  width: 2.04rem;
  height: 0.6rem;
  position: absolute;
  left: 0.72rem;
  z-index: 1;
}
.crumbs-img3 {
  width: 2.07rem;
  height: 0.6rem;
  position: absolute;
  left: 2.17rem;
}


//底部
/deep/ .footer-container {
  margin-top: 0.8rem;
}
</style>
